import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

// Models
import { ResponseStatus } from '../../shared/models/response-status.model';
import { CreateGroup, GroupDetail, GroupListElem } from '../models/group.model';


@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(private readonly http: HttpClient) { }

  createGroup(group: CreateGroup): Observable<any> {
    return this.http.post<CreateGroup>(`${environment.apiGatewayUrl}/ugc/api/v1/groups`, group);
  }

  updateGroup(group: CreateGroup, groupId: string): Observable<any> {
    return this.http.put<CreateGroup>(`${environment.apiGatewayUrl}/ugc/api/v1/groups/${groupId}`, group);
  }

  listGroups() {
    return this.http.get<GroupListElem[]>(`${environment.apiGatewayUrl}/ugc/api/v1/groups`);
  }

  getGroupDetail(groupId: string) {
    return this.http.get<GroupDetail>(`${environment.apiGatewayUrl}/ugc/api/v1/groups/${groupId}`);
  }

  deleteGroup(groupId: string) {
    return this.http.delete(`${environment.apiGatewayUrl}/ugc/api/v1/groups/${groupId}`);
  }

  toggleUserToGroup(groupId: string, action: { action: 'add' | 'remove', userId: string }) {
    return this.http.post<ResponseStatus>(`${environment.apiGatewayUrl}/ugc/api/v1/groups/${groupId}/user`, action);
  }

  // ROLE ADMIN
  listMyGroups(adminId: string) {
    return this.http.get<GroupListElem[]>(`${environment.apiGatewayUrl}/ugc/api/v1/groups/member/${adminId}`);
  }

  leaveGroup(adminId: string, groupId: string, reason: string) {
    const body = {
      groupId,
      action: 'remove',
      reason
    }

    return this.http.post<GroupListElem[]>(`${environment.apiGatewayUrl}/ugc/api/v1/groups/member/${adminId}`, body);
  }
}
